import ModalWidnow from "./ModalWindow.tsx";

interface ISchedule {
  children: any;
  setScheduleState: any;
  state: boolean;
  addButton?: any;
  RedirectTo?: string;
  onSubmit?: any;
}

export default function Sсhedule({
  children,
  setScheduleState,
  state,
  onSubmit,
}: ISchedule) {
  return (
    <ModalWidnow state={state} setState={setScheduleState}>
      <form onSubmit={onSubmit}>
        {children}
        <div className="flex flex-row justify-around items-stretch">
          <button
            className="w-16 h-6 cursor-pointer font-medium text-xs text-white bg-red-600 m-[20px_10px] p-[13px_8px] rounded-4xl border-none transition-all duration-250 ease-in-out
"
            onClick={() => {
              setScheduleState(false);
            }}
          >
            Отменить
          </button>
          <button
            type="submit"
            className="w-16 h-6 cursor-pointer font-medium text-xs text-white bg-green-500 m-[20px_10px] p-[13px_8px] rounded-4xl border-none transition-all duration-250 ease-in-out
"
          >
            Добавить
          </button>
        </div>
      </form>
    </ModalWidnow>
  );
}
